
import * as R from "ramda";
import axios from 'axios'

const SERVER_URL = `${process.env.VUE_APP_SERVER_URL}`;

const senStore = {
    namespaced: true,
    state: {
        questionform: {},
        questionmeta: {},
        "mode": "king",
        sencommand_selected: null,
        flag: "1",
        sencommand_options: [
            { text: "S", value: "1" },
            { text: "V", value: "2", disabled: false },
            { text: "C", value: "3", disabled: false },
            { text: "O", value: "4", disabled: false },
            { text: "IO", value: "5", disabled: false },
            { text: "DO", value: "6", disabled: false },
            { text: "M", value: "7", disabled: false },
            { text: "A", value: "8", disabled: false },
            { text: "전", value: "9", disabled: false },
            { text: "전.목", value: "10", disabled: false },
        ],
        ays_answers: [
            /*{ id: 1, text: "", strt: "" },
            { id: 2, text: "", strt: "" }, */
        ],
        comt_answers: [
            /*{ id: 1, text: "", strt: "" },
            { id: 2, text: "", strt: "" }, */
        ],
        shuffle_answers: [
            /*{ id: 1, text: "", strt: "" },
            { id: 2, text: "", strt: "" }, */

        ],
        senintent_options: [],
        SSub: [
            { value: "S", "text": "S" },
            { value: "가주어", "text": "가주어" },
            { value: "진주어", "text": "진주어" },

            // { value: "S1", "text": "S1" },
            // { value: "S2", "text": "S2" },
            // { value: "S3", "text": "S3" },
            // { value: "S4", "text": "S4" },
            { value: "S`", "text": "S`" },
            // { value: "S`1", "text": "S`1" },
            // { value: "S`2", "text": "S`2" },
            // { value: "S`3", "text": "S`3" },
            // { value: "S`4", "text": "S`4" },

            { value: "V", "text": "V" },
            // { value: "V1", "text": "V1" },
            // { value: "V2", "text": "V2" },
            // { value: "V3", "text": "V3" },
            // { value: "V4", "text": "V4" },
            { value: "V`", "text": "V`" },
            // { value: "V`1", "text": "V`1" },
            // { value: "V`2", "text": "V`2" },
            // { value: "V`3", "text": "V`3" },
            // { value: "V`4", "text": "V`4" },

            { value: "C", "text": "C" },
            // { value: "C1", "text": "C1" },
            // { value: "C2", "text": "C2" },
            // { value: "C3", "text": "C3" },
            // { value: "C4", "text": "C4" },
            { value: "C`", "text": "C`" },
            // { value: "C`1", "text": "C`1" },
            // { value: "C`2", "text": "C`2" },
            // { value: "C`3", "text": "C`3" },
            // { value: "C`4", "text": "C`4" },

            { value: "O", "text": "O" },
            { value: "가목적어", "text": "가목적어" },
            { value: "진목적어", "text": "진목적어" },

            // { value: "O1", "text": "O1" },
            // { value: "O2", "text": "O2" },
            // { value: "O3", "text": "O3" },
            // { value: "O4", "text": "O4" },
            { value: "O`", "text": "O`" },
            // { value: "O`1", "text": "O`1" },
            // { value: "O`2", "text": "O`2" },
            // { value: "O`3", "text": "O`3" },
            // { value: "O`4", "text": "O`4" },


            { value: "IO", "text": "IO" },
            // { value: "IO1", "text": "IO1" },
            // { value: "IO2", "text": "IO2" },
            // { value: "IO3", "text": "IO3" },
            // { value: "IO4", "text": "IO4" },
            { value: "IO`", "text": "IO`" },
            // { value: "IO`1", "text": "IO`1" },
            // { value: "IO`2", "text": "IO`2" },
            // { value: "IO`3", "text": "IO`3" },
            // { value: "IO`4", "text": "IO`4" },


            { value: "DO", "text": "DO" },
            // { value: "DO1", "text": "DO1" },
            // { value: "DO2", "text": "DO2" },
            // { value: "DO3", "text": "DO3" },
            // { value: "DO4", "text": "DO4" },
            { value: "DO`", "text": "DO`" },
            // { value: "DO`1", "text": "DO`1" },
            // { value: "DO`2", "text": "DO`2" },
            // { value: "DO`3", "text": "DO`3" },
            // { value: "DO`4", "text": "DO`4" },


            { value: "M", "text": "M" },
            // { value: "M1", "text": "M1" },
            // { value: "M2", "text": "M2" },
            // { value: "M3", "text": "M3" },
            // { value: "M4", "text": "M4" },
            { value: "M`", "text": "M`" },
            // { value: "M`1", "text": "M`1" },
            // { value: "M`2", "text": "M`2" },
            // { value: "M`3", "text": "M`3" },
            // { value: "M`4", "text": "M`4" },

            { value: "A", "text": "A" },
            // { value: "A1", "text": "A1" },
            // { value: "A2", "text": "A2" },
            // { value: "A3", "text": "A3" },
            // { value: "A4", "text": "A4" },
            { value: "A`", "text": "A`" },
            // { value: "A`1", "text": "A`1" },
            // { value: "A`2", "text": "A`2" },
            // { value: "A`3", "text": "A`3" },
            // { value: "A`4", "text": "A`4" },

            { value: "전", "text": "전" },
            // { value: "전1", "text": "전1" },
            // { value: "전2", "text": "전2" },
            // { value: "전3", "text": "전3" },
            // { value: "전4", "text": "전4" },
            { value: "전`", "text": "전`" },
            // { value: "전`1", "text": "전`1" },
            // { value: "전`2", "text": "전`2" },
            // { value: "전`3", "text": "전`3" },
            // { value: "전`4", "text": "전`4" },

            { value: "전목", "text": "전목" },
            // { value: "전목1", "text": "전목1" },
            // { value: "전목2", "text": "전목2" },
            // { value: "전목3", "text": "전목3" },
            // { value: "전목4", "text": "전목4" },
            { value: "전목`", "text": "전목`" },
            // { value: "전목`1", "text": "전목`1" },
            // { value: "전목`2", "text": "전목`2" },
            // { value: "전목`3", "text": "전목`3" },
            // { value: "전목`4", "text": "전목`4" },

            { value: "K1", "text": "()" },
            { value: "K2", "text": "[]" },
            { value: "병렬", "text": "병렬" },



        ],
        senlvl_options: [
            { text: "LV1(중학)", value: "1" },
            { text: "LV2(예비고~고1)", value: "2", disabled: false },
            { text: "LV3(고2~고3)", value: "3", disabled: false },
            { text: "LV4(고3~고등심화)", value: "4", disabled: false },
        ],


        senvalid: {
            intent: '',
        }


    },
    getters: {
        GET_SENCOMMAND_OPTIONS: state => state.sencommand_options
    },
    mutations: {
        MU_SENCOMMAND_SELECTED: (state, payload) => {
            state.sencommand_selected = payload;
        },
        MU_AYS_ANSWER_APPEND(state, payload) {
            state.ays_answers.push(payload);
        },
        MU_COMT_ANSWER_APPEND(state, payload) {
            state.comt_answers.push(payload);
        },
        MU_SHUFFLE_ANSWER_APPEND(state, payload) {
            state.shuffle_answers.push(payload);
        },

        MU_UNIFIED_ANSWER_BIND(state, payload) {

            let ays = R.filter(f => {
                return f.flag == "1";
            }, payload).map(f => {
                f.text = f.ans1;
                f.strt = f.ans2;

                f.intent = JSON.parse(f.intent);
                return f;
            });

            console.log(ays);

            state.ays_answers = ays;

            let comt = R.filter(f => {
                return f.flag == "2";
            }, payload).map(f => {
                f.text = f.ans1;
                f.strt = f.ans2;
                f.intent = JSON.parse(f.intent);
                return f;
            });

            state.comt_answers = comt;

            let shufles = R.filter(f => {
                return f.flag == "3";
            }, payload).map(f => {
                f.text = f.ans1;
                f.strt = f.ans2;
                f.intent = JSON.parse(f.intent);
                return f;
            });

            state.shuffle_answers = shufles;



        },

        MU_RESET_ANSWERS: (state) => {
            state.ays_answers = [];
            state.comt_answers = [];
            state.shuffle_answers = [];
        }


    },
    actions: {
        AC_SENCOMMAND_SELECTED: ({ commit,/*state*/ }, payload) => {
            commit('MU_SENCOMMAND_SELECTED', payload);
        },
        AC_AYS_ANSWER_APPEND({ commit }, payload) {
            commit('MU_AYS_ANSWER_APPEND', payload);
        },
        AC_COMT_ANSWER_APPEND({ commit }, payload) {
            commit('MU_COMT_ANSWER_APPEND', payload);
        },

        AC_SHUFFLE_ANSWER_APPEND({ commit }, payload) {
            commit('MU_SHUFFLE_ANSWER_APPEND', payload);
        },


        AC_FLAG_UPDATE({ commit, state }, payload) {
            state.flag = payload;
        },
        AC_AYS_ANSWER_EXCHAGE({ commit, state }, payload) {
            state.ays_answers = payload;
        },
        AC_COMT_ANSWER_EXCHAGE({ commit, state }, payload) {
            state.comt_answers = payload;
        },

        AC_SHUFFLE_ANSWER_EXCHAGE({ commit, state }, payload) {
            state.shuffle_answers = payload;
        },

        AC_UPDATE_TXT({ commit, state }, { ans, txt }) {

            if (state.flag == "1") { //분석
                let upt = R.map(item => {
                    if (item.id == ans.id) {
                        item.text = txt;
                    }
                    return item;
                }, state.ays_answers);

                state.ays_answers = upt;

            } else if (state.flag == "2") {  //해석
                let upt = R.map(item => {
                    if (item.id == ans.id) {
                        item.text = txt;
                    }
                    return item;
                }, state.comt_answers);

                state.comt_answers = upt;

            } else if (state.flag == "3") { // 스크램블

                let upt = R.map(item => {
                    if (item.id == ans.id) {
                        item.text = txt;
                    }
                    return item;
                }, state.shuffle_answers)
                state.shuffle_answers = upt;

            }
        },

        /**
         *
         *
         * @param {*} { commit, state, rootState }
         */
        async AC_SAVE_SEN({ commit, state, rootState, dispatch, context }) {



            if (state.ays_answers.length > 0) {
                // state.senvalid.intent = "invalid";
                let cnt = R.filter(f => {
                    return f.intent == ""
                }, state.ays_answers).length;

                if (cnt > 0) {
                    state.senvalid.intent = "invalid";
                    return false;

                } else {
                    state.senvalid.intent = "";
                }

            } else {
                state.senvalid.intent = "";
            }

            if (state.shuffle_answers.length > 0) {
                // state.senvalid.intent = "invalid";
                let cnt = R.filter(f => {
                    return f.intent == ""
                }, state.shuffle_answers).length;

                if (cnt > 0) {
                    state.senvalid.intent = "invalid";
                    return false;

                } else {
                    state.senvalid.intent = "";
                }

            } else {
                state.senvalid.intent = "";
            }











            commit("Updateformvalid", null, { root: true })
            let formvalid = rootState.formvalid;
            if (!formvalid) {
                return false;
            }






            let book_id = rootState.book_id;
            rootState.questionform.book_id = book_id + "";
            rootState.questionmeta.book_id = book_id + "";

            let as = R.map(f => {
                f.intent = JSON.stringify(f.intent);
                return f;
            }, state.ays_answers);

            let ca = R.map(f => {
                f.intent = JSON.stringify(f.intent);
                return f;

            }, state.comt_answers);

            let sa = R.map(f => {
                f.intent = JSON.stringify(f.intent);
                return f;
            }, state.shuffle_answers);


            let postobj = {
                questionform: rootState.questionform,
                questionmeta: rootState.questionmeta,
                ays_answers: as,
                comt_answers: ca,
                shuffle_answers: sa
            }



            //변경되는 스크램블 내용 업데이트



            if (rootState.questionform.id == "") {
                // 문제 등록 모드
                let url = `${SERVER_URL}/senquestion`;
                return axios.post(url, postobj).then(resp => {
                    alert("문제등록완료");
                    commit("updateDebug", "11", { root: true });
                    commit("resetQuestionForm", null, { root: true });
                    commit("resetQuestionMeta", null, { root: true })
                    commit("MU_RESET_ANSWERS");

                    let book_id = rootState.book_id;
                    dispatch("loadQuestionList", book_id, { root: true });
                    dispatch("getNextSerial", null, { root: true });

                    rootState.bookform.qcnt = rootState.bookform.qcnt + 1;
                    return true;

                });



            } else {
                // 문제 수정 모드
                // 구문/영작훈련  저장 및 수정 위치
                let url = `${SERVER_URL}/senquestion/${rootState.questionform.id}`;
                return axios.put(url, postobj).then(resp => {
                    alert("문제수정완료");
                    commit("resetQuestionForm", null, { root: true });
                    commit("resetQuestionMeta", null, { root: true })
                    commit("MU_RESET_ANSWERS");
                    let book_id = rootState.book_id;
                    dispatch("loadQuestionList", book_id, { root: true });
                    return true;
                });
            }

        },
        loadSenIntent({ state }) {
            // console.log("loadSen");
            let url = `${SERVER_URL}/senintent`;
            axios.get(url).then(resp => {
                state.senintent_options = resp.data;
            });

        }


    }
}

export default senStore;